import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { AmountsCargoEnum } from "../enums/amountsCargo.enum";
import { Cargo } from "../interfaces/cargo";
import { Utils } from "../resources/utils";
import { Injectable } from "@angular/core";
import { ModalEnum } from "../enums/modal.enum";
import { TRIP_TYPES } from "../enums/tripTypes.enum";
import { CargoGenerateService } from "../services/cargoGenerate.service";
import { DialogSurveyComponent } from "src/app/shared/dialog-survey/dialog-survey.component";
import { AddressCargo } from "../interfaces/addressCargo";
import { LocationAddress } from "../interfaces/locationAddress";
import moment from "moment";
import { Observable } from "rxjs";
import { DateManager } from "./date.manager";
import { GoogleService } from "../services/google.service";
import { CargoApproval } from "../interfaces/cargo-approval";
import { BasicPerson } from "../interfaces/basicPerson";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";
import { ServiceType } from "../interfaces/serviceType";
import { AuthService } from "../services/authentication.service";
import { VehicleInspect } from "../interfaces/vehicleInspect";
import { CargoStateEnum } from "../enums/cargoState.enum";
import { CargoCreationModalComponent } from "src/app/modules/cargo/cargo-creation-modal/cargo-creation-modal.component";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { ConsignmentCargo } from "../interfaces/consignmentCargo";
import { Origin } from "../interfaces/origin";
import { Destination } from "../interfaces/destination";
import { ConsignmentAddressOption, ConsignmentCityOption, ConsignmentThirdPartyOption } from "src/app/shared/consignment-card/consignment-card.component";
import { SettingId } from "../interfaces/saas-config";
import { ThirdParty } from "../interfaces/thirdParty";
import { FingerprintHistory } from "../interfaces/fingerprintHistory";
import { CargoApprovalConsignment } from "../interfaces/cargo-approval-consignment";
import { PermissionRole } from "../resources/permission-role";
import { Permission } from "../resources/permission";
import haversineDistance from "haversine-distance";

export type Arrive = { location: LocationAddress, arrive: Date, address: string };

/** `code` que el backend manda cuando bloquea por el minimo de viajes del vehiculo vs. el perfil de riesgo. */
export const VEHICLE_TRIP_VALIDATION_EXCEPTION_CODE = 'com.teclogi.dto.exceptions.cargo.app.VehicleTripValidationException';

@Injectable()
export class CargoManager {
  private readonly dateFieldsToPatch = [
    'upload.arrival',
    'upload.entry',
    'upload.departure',
    'download.arrival',
    'download.entry',
    'download.departure'
  ];
  private readonly otherFieldsToPatch = [
    'upload.reason',
    'upload.observation',
    'download.reason',
    'download.observation'
  ];

  public amountsCargo = [
    {
      start: AmountsCargoEnum.LOW_START,
      end: AmountsCargoEnum.LOW_END
    },
    {
      start: AmountsCargoEnum.MEDIUM_START,
      end: AmountsCargoEnum.MEDIUM_END
    },
    {
      start: AmountsCargoEnum.HIGH_START,
      end: AmountsCargoEnum.HIGH_END
    }
  ];

  constructor(
    public utils: Utils,
    public matDialog: MatDialog,
    public cargoGenerateService: CargoGenerateService,
    public googleService: GoogleService,
    private authService: AuthService,
    private router: Router,
    private permissionRole: PermissionRole
  ) {

  }

  public getTypeCargo(cargo: Cargo): TRIP_TYPES {
    let tripType: TRIP_TYPES;
    try {
      tripType = cargo.cargoModel.tripType.name;
    } catch (e) {
      console.error(e);
    }
    if (this.utils.isEmpty(tripType)) {
      tripType = TRIP_TYPES.URBAN;
    }
    return tripType;
  }

  public getProductNameCargo(cargo: Cargo): string {
    let productName: string = this.utils.getNestedValue(cargo, 'cargoFeature.productType.name');
    return !this.utils.isEmpty(productName) ? productName : 'PRODUCTOS VARIOS';
  }

  public checkInspection(cargo: Cargo, userId: BasicPerson, licensePlate: string): Promise<VehicleInspect> {
    return new Promise(async (resolve, reject) => {
      //Inspeccionar vehiculo
      const typeOfInspection: 'form' | 'document' = await this.modalTypeOfInspection('vehicle');
      if (!typeOfInspection) return reject();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        user: userId,
        licensePlate,
        id: cargo.id,
        cargo,
        typeOfInspection
      };
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.autoFocus = false;
      const dialoRef = this.matDialog.open(DialogSurveyComponent, dialogConfig);
      dialoRef.afterClosed().subscribe(result => {
        if (result && result.id) {
          resolve(result.id);
        } else {
          reject();
        }
      });
    });
  }

  public openExistingVehicleInspection(params: {
    cargo: Cargo,
    inspection: VehicleInspect,
    licensePlate: string,
    user?: BasicPerson
  }): Promise<any> {
    const typeOfInspection: 'form' | 'document' = params.inspection && params.inspection.inspectionDocument ? 'document' : 'form';
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      inspect: params.inspection,
      disabled: true,
      user: params.user,
      licensePlate: params.licensePlate,
      id: params.cargo && params.cargo.id,
      cargo: params.cargo,
      typeOfInspection
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    return this.matDialog.open(DialogSurveyComponent, dialogConfig).afterClosed().toPromise();
  }

  /*public isTripTypeNational(cargo: Cargo): boolean {
    let state: boolean = false;
    try {
      return this.utils.getNestedValue(cargo, 'cargoModel.tripType.name') && cargo.cargoModel.tripType.name !== TRIP_TYPES.URBAN && cargo.cargoModel.tripType.name !== TRIP_TYPES.INTERNATIONAL && cargo.cargoModel.tripType.name !== TRIP_TYPES.LAST_MILE && ((this.utils.isDefined(cargo.cargoModel.tripType.category) && cargo.cargoModel.tripType.category !== TRIP_TYPES.URBAN) || !this.utils.isDefined(cargo.cargoModel.tripType.category));
    } catch (e) {
      console.error(e);
    }
    return state;
  }*/

  private timeAmPmTo24H(address: AddressCargo): string {
    if (!address.timeType) return address.time;
    if (address.time.startsWith('12') && address.timeType == 'AM') return address.time.replace('12', '00');
    if (address.time.startsWith('12') && address.timeType == 'PM') return address.time;
    if (address.timeType == 'PM') return `${parseInt(address.time.slice(0, 2)) + 12}:${address.time.slice(3, 5)}`;
    return address.time;
  }

  private processAddressToCheckTripTimes(address: AddressCargo, arrivalDate: Date | string): Arrive {
    // Completar con 0 a la izquierda 5:00 -> 05:00
    if (!address || !address.address)
      throw new Error(`No se ha diligenciado la dirección de algun origen o destino`);
    if (!address.time)
      throw new Error(`La dirección ${address.address} no tiene hora estimada`);
    address.time = address.time.padStart(5, '0');
    const time24H = this.timeAmPmTo24H(address);

    // Check if it is valid location
    if (!address.location || (!address.location.lat && !address.location.lng))
      throw new Error(`La dirección ${address.address} no tiene una geopocisión válida`);

    const arrivalDateDate = typeof arrivalDate === 'string' ? DateManager.stringToDate(arrivalDate) : arrivalDate;
    return {
      location: address.location as google.maps.LatLngLiteral,
      arrive: (DateManager.stringToDate(`${DateManager.setStartOfDay(arrivalDateDate).toISOString().split('T')[0]}T${time24H}`, 'YYYY-MM-DDTHH:mm:ssZ')),
      address: address.address
    }
  }

  public checkTripTimes(cargo: Cargo, validateOrigin = true, validateDestination = true): Observable<{ valid: boolean, min: number, address: string }> {
    const arrivals: Array<Arrive> = [];
    const dateLoad = cargo.dateLoad;
    const origin = cargo.cargoFeature.uploadDownload.origin;
    const destinations = cargo.cargoFeature.uploadDownload.destination;

    try {
      if (validateOrigin)
        origin.addresses.forEach(address => arrivals.push(this.processAddressToCheckTripTimes(address, dateLoad)));
      if (validateDestination)
        destinations.forEach(destination => {
          const dateDownload = destination.downloadDate;
          destination.addresses.forEach(address => arrivals.push(this.processAddressToCheckTripTimes(address, dateDownload)));
        });
    } catch (err) {
      return new Observable(observer => observer.error(err));
    }
    return this.validateTripTimes(arrivals);
  }

  public validateTripTimes(arrivals: Arrive[]): Observable<{ valid: boolean, min: number, address: string, index: number }> {
    if (!arrivals.length)
      return new Observable(observer => observer.error('No se han registrado direcciones de origen o destino'));
    const observables: Array<Observable<{ valid: boolean, min: number, address: string, index: number }>> = [];
    // Process all arrivals times from [1] ... [end]
    for (let i = 1; i < arrivals.length; i++) {
      const prev = arrivals[i - 1];
      const next = arrivals[i];

      observables.push(new Observable<{ valid: boolean, min: number, address: string, index: number }>(
        (observer) => this.googleService
          .calculateMinRouteTime(
            prev.location,
            next.location,
            (response, status) => {
              if (status !== "OK") {
                const distance = haversineDistance(prev.location, next.location) / 1000;
                const time = distance / 45;
                const min = (4 / 5) * (time * 3600); // Minimo tiempo estimado en segundos
                const duration = DateManager.dateDiff(next.arrive, null, prev.arrive, null, 'seconds');
                const isValid: boolean = !(duration - min < 0);
                observer.next({ valid: isValid, min, address: arrivals[i].address, index: i });
              }
              else {
                const times: Array<number> = [];
                const distance: Array<number> = [];
                const description: Object = {};

                response.routes.forEach((route) => {
                  route.legs.forEach((leg) => {
                    times.push(leg.duration.value);
                    distance.push(leg.distance.value);

                    description[`${leg.duration.value}`] = {
                      duration: leg.duration.text,
                      distance: leg.distance.text,
                    };
                  });
                });
                const min = (4 / 5) * Math.min(...times); // Minimo tiempo estimado en segundos
                const duration = DateManager.dateDiff(next.arrive, null, prev.arrive, null, 'seconds');
                const isValid: boolean = !(duration - min < 0);
                observer.next({ valid: isValid, min, address: arrivals[i].address, index: i });
              }
              observer.complete();
            })));
    }

    return new Observable<{ valid: boolean, min: number, address: string, index: number }>(
      observer => {
        let pending = observables.length;
        let result = true;
        let min = 0;
        let address = '';
        observables.forEach(
          (subscribable, i) => {
            subscribable.subscribe({
              next: (success: { valid: boolean, min: number, address: string, index: number }) => {
                if (success && success.min) min = success.min;
                if (!success || !success.valid) {
                  observer.next({ valid: false, min, address: success.address, index: success.index });
                  observer.complete();
                } else {
                  pending--;
                  result = result && success.valid;
                  address = success.address;
                }
              },
              error: (err) => {
                observer.error(`Ocurrió un error al encontrar una ruta entre la dirección ${arrivals[i].address} y la dirección ${arrivals[i + 1].address}, por favor verifique las direcciones y vuelva a intentar`);
                observer.complete();
              },
              complete: () => {
                if (pending == 0) {
                  observer.next({ valid: result, min, address, index: -1 });
                  observer.complete();
                }
              }
            })
          }
        )
      }
    );
  }

  public checkRedirectCargo(cargo: Cargo, cameFrom: 'menu-service' | 'tracking' | 'detail'): { redirect: boolean, path: string } {
    if (!cargo) return { redirect: false, path: '' };
    if (cargo.state === CargoStateEnum.REQUEST)
      return { redirect: cameFrom !== 'menu-service', path: '/service-request-form/menu-service/' + cargo.consecutive.toString() };
    else if (cargo.state === CargoStateEnum.START_SERVICE)
      return { redirect: cameFrom !== 'tracking', path: '/cargo/tracking/' + cargo.consecutive };
    else
      return { redirect: cameFrom !== 'detail', path: '/cargo/detail/' + cargo.consecutive };
  }

  public requestEnvironmentType(vehicleType: string, bodyworkType: string): boolean {
    return vehicleType === "TRACTOCAMION" || bodyworkType === "FURGON";
  }

  public getRealDate(date: string, time: string): Date {
    return DateManager.stringToDate(`${DateManager.stringToDate(date).toISOString().split('T')[0]}T${time} -0500`, 'YYYY-MM-DDTHH:mm:ssZ');
  }

  public createCargoApproval(cargo: Cargo, cargoConsignments: ConsignmentCargo[]): CargoApproval {
    const lastAddressOrigin: AddressCargo = cargo.cargoFeature.uploadDownload.origin.addresses[cargo.cargoFeature.uploadDownload.origin.addresses.length - 1];
    const destinations = cargo.cargoFeature.uploadDownload.destination;
    const consignments = [];
    if (this.utils.isSameCity(cargo)) return { cargoId: cargo.id, consignment: [] };
    const OriginTimeCargo = this.getRealDate(cargo.dateLoad, lastAddressOrigin.time);
    for (const i in destinations) {
      for (const j in destinations[i].addresses) {
        const address = destinations[i].addresses[j];
        if (address && address.consignments) {
          for (const consignment of address.consignments) {
            const consignmentIndex = address.consignments.indexOf(consignment);
            const cargoConsignment = consignmentIndex !== -1 ? cargoConsignments[consignmentIndex] : null;
            const hasStartDateLoad = lastAddressOrigin.durationTime && lastAddressOrigin.durationTime.startDate;
            const originTime = hasStartDateLoad
              ? DateManager.stringToDate(lastAddressOrigin.durationTime.startDate)
              : cargoConsignment && cargoConsignment.load && cargoConsignment.load.date
                ? this.getRealDate(DateManager.formatDate(cargoConsignment.load.date, 'DD/MM/YYYY', 'YYYY-MM-DD'), cargoConsignment.load.appointmentTime)
                : OriginTimeCargo;
            const hasEndDateLoad = lastAddressOrigin.durationTime && lastAddressOrigin.durationTime.endDate;
            const originTimeDeparture = hasEndDateLoad
              ? DateManager.stringToDate(lastAddressOrigin.durationTime.endDate)
              : cargoConsignment && cargoConsignment.load
                ? this.getDepartureDate(cargoConsignment.load.appointmentTime, cargoConsignment.load.hours, cargoConsignment.load.minutes, DateManager.formatDate(cargoConsignment.load.date, 'DD/MM/YYYY'))
                : this.getDepartureDate(address.time, address.timePact, address.minutePact, cargo.dateLoad);
            const hasInitialCompliment = address.dateTimeDownload && address.dateTimeDownload[consignmentIndex];
            const hasStartDateDownload = address.durationTime && address.durationTime.startDate;
            const dateDownload = hasInitialCompliment
              ? DateManager.stringToDate(address.dateTimeDownload[consignmentIndex])
              : hasStartDateDownload
                ? DateManager.stringToDate(address.durationTime.startDate)
                : cargoConsignment && cargoConsignment.unload && cargoConsignment.unload.date
                  ? this.getDownloadDateBase(address, cargoConsignment.unload.appointmentTime, DateManager.formatDate(cargoConsignment.unload.date, 'DD/MM/YYYY'))
                  : this.getDownloadDateBase(address, address.time, destinations[i].downloadDate);
            const hasEndDateDownload = address.durationTime && address.durationTime.endDate;
            const dateDownloadDeparture = hasEndDateDownload
              ? DateManager.stringToDate(address.durationTime.endDate)
              : cargoConsignment && cargoConsignment.unload
                ? this.getDepartureDate(cargoConsignment.unload.appointmentTime, cargoConsignment.unload.hours, cargoConsignment.unload.minutes, DateManager.formatDate(cargoConsignment.unload.date, 'DD/MM/YYYY'))
                : this.getDepartureDate(address.time, address.timePact, address.minutePact, cargo.dateLoad);
            const consigmentForm = {
              id: address.consignments[0],
              destinationId: i,
              addressId: address.id,
              amountDelivered: cargoConsignment && cargoConsignment.totalWeight ? cargoConsignment.totalWeight
                : address.cargoMeasure && address.cargoMeasure.totalWeigth ? address.cargoMeasure.totalWeigth : 0,
              upload: {
                arrival: DateManager.formatDate(DateManager.add(originTime, 16, 'minutes')),
                entry: DateManager.formatDate(DateManager.add(originTime, 30, 'minutes')),
                departure: DateManager.formatDate(originTimeDeparture),
              },
              download: {
                entry: DateManager.dateToString(DateManager.add(dateDownload, 16, 'minutes')),
                departure: DateManager.dateToString(dateDownloadDeparture),
              }
            };
            if ((cargoConsignment && !cargoConsignment.approvalInitialId) || (!cargoConsignment && !address.approvalInitialConsignment))
              consigmentForm.download['arrival'] = DateManager.dateToString(DateManager.add(dateDownload, 0, 'minutes'));
            consignments.push(consigmentForm);
          }
        }
      }
    }
    return { cargoId: cargo.id, consignment: consignments };
  }

  public createCargoApprovalWithLastUserEdition(
    cargo: Cargo,
    cargoConsignments: ConsignmentCargo[],
    fingerprintHistories: FingerprintHistory[]
  ): CargoApproval {
    const cargoApproval = this.createCargoApproval(cargo, cargoConsignments);
    return this.applyLastFingerprintApproval(cargoApproval, fingerprintHistories);
  }

  public applyLastFingerprintApproval(
    cargoApproval: CargoApproval,
    fingerprintHistories: FingerprintHistory[]
  ): CargoApproval {
    if (!cargoApproval || !cargoApproval.consignment || !cargoApproval.consignment.length) return cargoApproval;
    const lastFingerprintApproval = this.getLastFingerprintApproval(fingerprintHistories);
    if (!lastFingerprintApproval || !lastFingerprintApproval.approval || !lastFingerprintApproval.approval.consignment) return cargoApproval;
    const previousConsignments = lastFingerprintApproval.approval.consignment;
    if (!previousConsignments.length) return cargoApproval;
    cargoApproval.consignment.forEach((consignment: CargoApprovalConsignment) => {
      const previousFingerprintApproval = previousConsignments.find(c => c && c.id === consignment.id);
      if (!previousFingerprintApproval) return;
      [...this.dateFieldsToPatch, ...this.otherFieldsToPatch].forEach((field) => {
        const value = this.utils.getNestedValue(previousFingerprintApproval, field);
        if (!value) return;
        this.setNestedValue(consignment, field, value);
      });
    });
    return cargoApproval;
  }

  private getLastFingerprintApproval(
    fingerprintHistories: FingerprintHistory[]
  ): { approval: CargoApproval, fingerprint: any } {
    if (!fingerprintHistories || !fingerprintHistories.length) return null;
    const orderedHistory = [...fingerprintHistories].sort((a, b) => {
      const dateA = DateManager.stringToDate(this.utils.getNestedValue(a, 'fingerprint.date'));
      const dateB = DateManager.stringToDate(this.utils.getNestedValue(b, 'fingerprint.date'));
      if (!dateA && !dateB) return 0;
      if (!dateA) return -1;
      if (!dateB) return 1;
      return DateManager.isBefore(dateA, dateB, 'seconds') ? -1 : 1;
    });
    const lastHistory = orderedHistory[orderedHistory.length - 1];
    return lastHistory ? { approval: lastHistory.data as CargoApproval, fingerprint: lastHistory.fingerprint } : null;
  }

  private setNestedValue(target: any, path: string, value: any): void {
    if (!target || !path) return;
    const keys = path.split('.');
    const lastKey = keys.pop();
    const nestedTarget = keys.reduce((acc, key) => {
      if (!acc[key] || typeof acc[key] !== 'object') acc[key] = {};
      return acc[key];
    }, target);
    if (!lastKey) return;
    nestedTarget[lastKey] = value;
  }

  public getDownloadDateBase(address: AddressCargo, addressTime: string, downloadDate: string): string {
    let dateDownload: string;
    if (address.dateTimeDownload && address.dateTimeDownload[0])
      dateDownload = address.dateTimeDownload[0];
    else if (address.durationTime && address.durationTime.startDate)
      dateDownload = address.durationTime.startDate;
    else dateDownload = `${downloadDate.slice(0, 10)} ${addressTime} -0500`;
    return dateDownload;
  }

  public getDepartureDate(addressTime: string, addressTimePact: number, addressMinutePact: number, dateLoad: string): Date {
    let originTime = this.getRealDate(dateLoad, addressTime);
    if (addressTimePact)
      originTime = DateManager.add(originTime, addressTimePact, 'hours');
    if (addressMinutePact)
      originTime = DateManager.add(originTime, addressMinutePact, 'minutes');
    if (!addressTimePact && !addressMinutePact)
      originTime = DateManager.add(originTime, 1, 'hours');
    return originTime;
  }

  public async modalPreoperationalInspection(cargo: Cargo, licensePlate?: string, description?: string): Promise<'Delegated' | 'Inspected' | null> {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Se requiere inspeccionar el vehículo`,
      iconAlert: true,
      description: description ? description : `Se requiere realizar una inspección preoperacional del vehículo para verificar sus condiciones técnicas y de seguridad antes de iniciar el servicio. ¿Desea realizar la inspección ahora o delegarla al conductor?`,
      labelButton1: 'Delegar al conductor',
      labelButton2: 'Realizar inspección',
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialog = this.matDialog.open(DialogComponent, dialogConfig);
    const result = await dialog.afterClosed().toPromise();
    if (!result || !result.state) return null;
    if (result.refuse && result.refuse === "Delegar al conductor")
      return 'Delegated';

    const typeOfInspection: 'form' | 'document' = await this.modalTypeOfInspection('vehicle');
    if (!typeOfInspection) return null;

    dialogConfig.data = {
      user: this.authService.getUserSession().information,
      licensePlate: licensePlate ? licensePlate : cargo.licensePlate,
      id: cargo.id,
      cargo: cargo,
      typeOfInspection
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogSurveyComponent, dialogConfig);
    const resultSurvey = await dialogRef.afterClosed().toPromise();
    if (!!resultSurvey) return 'Inspected';
    return null;
  }

  public async modalTypeOfInspection(typeOfInspection: 'container' | 'vehicle'): Promise<'form' | 'document' | null> {
    const hasVehicleInspectionByDocument = this.authService.hasCompanySettingEnabled(SettingId.ENABLE_VEHICLE_INSPECTION_BY_DOCUMENT);
    const hasVehicleInspectionByForm = this.authService.hasCompanySettingEnabled(SettingId.ENABLE_VEHICLE_INSPECTION_BY_FORM);
    const hasContainerInspectionByDocument = this.authService.hasCompanySettingEnabled(SettingId.ENABLE_CONTAINER_INSPECTION_BY_DOCUMENT);
    const hasContainerInspectionByForm = this.authService.hasCompanySettingEnabled(SettingId.ENABLE_CONTAINER_INSPECTION_BY_FORM);

    const settings = {};
    if (typeOfInspection === 'vehicle') {
      settings['document'] = hasVehicleInspectionByDocument;
      settings['form'] = hasVehicleInspectionByForm;
    } else {
      settings['document'] = hasContainerInspectionByDocument;
      settings['form'] = hasContainerInspectionByForm;
    }
    if (settings['document'] && !settings['form']) return 'document';
    if (!settings['document'] && settings['form']) return 'form';

    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Seleccione el tipo de inspección`,
      iconAlert: true,
      description: `Puede realizar la inspección ${typeOfInspection === 'container' ? 'a las unidades de carga' : 'preoperacional del vehículo'} subiendo un documento o llenando el formulario. ¿Cómo desea continuar?`,
      labelButton1: 'Subir documento',
      labelButton2: 'Llenar formulario',
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialog = this.matDialog.open(DialogComponent, dialogConfig);
    const result = await dialog.afterClosed().toPromise();
    if (!result || !result.state) return null;
    if (result.refuse && result.refuse === "Llenar formulario")
      return 'form';
    return 'document';
  }

  public async modalCargoCreation(cargos: Cargo[], title: string, cargosWithErrors?: { consecutive: string, error: string }[], cargosWithoutErrors?: string[]) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title,
      cargos
    };
    if (cargosWithErrors) dialogConfig.data.cargosWithErrors = cargosWithErrors;
    if (cargosWithoutErrors) dialogConfig.data.cargosWithoutErrors = cargosWithoutErrors;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialog = this.matDialog.open(CargoCreationModalComponent, dialogConfig);
    const result = await dialog.afterClosed().toPromise();
    if (!result || !result.path) return;
    this.router.navigate([result.path]);
  }

  public async preventContinueCargosWithBill(cargos: Cargo[]): Promise<{ continueAnyway: boolean }> {
    if (!cargos || cargos.length === 0) return { continueAnyway: true };
    const filteredCargos: { cargo: Cargo, cashed: boolean, validated: boolean }[] = cargos.filter(cargo =>
      cargo && cargo.shippingCost && (cargo.shippingCost.cashed || cargo.shippingCost.billId || this.utils.getNestedValue(cargo, 'prevalidation.valid')))
      .map(cargo => ({
        cargo: cargo,
        cashed: !!(cargo.shippingCost.cashed || cargo.shippingCost.billId),
        validated: !!this.utils.getNestedValue(cargo, 'prevalidation.valid')
      }));
    if (!filteredCargos.length) return { continueAnyway: true };

    let dialogConfig = new MatDialogConfig();
    const description = cargos.length === 1
      ? `¿Está seguro que desea continuar?`
      : filteredCargos.length === 1
        ? `El servicio ${filteredCargos[0].cargo.consecutive} esta ${filteredCargos[0].cashed ? 'facturado' : 'validado para facturar'}, ¿Está seguro que desea continuar?`
        : `Los servicios ${filteredCargos.map(cargo => cargo.cargo.consecutive).join(', ')} estan ${filteredCargos.map(cargo => cargo.cashed ? 'facturados' : 'validados para facturar').join(', ')}, ¿Está seguro que desea continuar?`;
    dialogConfig.data = {
      title: cargos.length === 1
        ? `El servicio ${cargos[0].consecutive} esta ${filteredCargos[0].cashed ? 'facturado' : 'validado para facturar'}`
        : filteredCargos.length === 1
          ? `El servicio ${filteredCargos[0].cargo.consecutive} esta ${filteredCargos[0].cashed ? 'facturado' : 'validado para facturar'}`
          : `Hay ${filteredCargos.length} servicios ${filteredCargos.map(cargo => cargo.cashed ? 'facturados' : 'validados para facturar').join(', ')}`,
      iconAlert: true,
      descriptionHTML: `<div class="text-center text-bold">${description}</div>`,
      labelButton1: 'Cancelar',
      labelButton2: 'Continuar',
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialog = this.matDialog.open(DialogComponent, dialogConfig);
    const result = await dialog.afterClosed().toPromise();
    if (!result || !result.state || !result.refuse || result.refuse === "Cancelar") return { continueAnyway: false };
    return { continueAnyway: true };
  }

  /**
   * Muestra el motivo por el que el servicio no cumple las reglas de riesgo (vehículo, tipo de viaje
   * o valor de mercancía) al guardar o crear, tal como lo informa el backend. El botón "Continuar de
   * todos modos" solo aparece si el usuario tiene el permiso `cargo.overrideRiskValidation`; sin el
   * permiso, el diálogo es puramente informativo (solo "Cerrar").
   */
  public async showRiskValidationBlockedDialog(message: string): Promise<{ continueAnyway: boolean }> {
    const canOverride = this.permissionRole.hasPermission(Permission.cargo.module, Permission.cargo.overrideRiskValidation);
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'El servicio no cumple las reglas de riesgo',
      iconAlert: true,
      descriptionHTML: `<div class="text-center">${message}</div>`,
      labelButton1: 'Cerrar',
      ...(canOverride ? { labelButton2: 'Continuar de todos modos' } : {}),
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialog = this.matDialog.open(DialogComponent, dialogConfig);
    const result = await dialog.afterClosed().toPromise();
    const continueAnyway = !!(canOverride && result && result.state && result.refuse === 'Continuar de todos modos');
    return { continueAnyway };
  }

  public processAddressesWithThirdParties(addresses: AddressCargo[]): ConsignmentThirdPartyOption[] {

    const thirdParties: { [key: string]: { thirdParty: ThirdParty, addresses: ConsignmentAddressOption[] } } = {};
    const generateThirdPartyKey = (thirdParty: ThirdParty): string => {
      if (!thirdParty) return '';
      const name = thirdParty.name || '';
      const documentType = thirdParty.documentType || '';
      const documentNumber = thirdParty.documentNumber || '';
      return `${name}_${documentType}_${documentNumber}`.toLowerCase();
    }
    addresses.forEach((address, indexAddress) => {
      if (this.utils.addressHasThirdParty(address)) {
        const thirdParty: ThirdParty = this.utils.getNestedValue(address, 'thirdPartyConsignment');
        const thirdPartyKey = generateThirdPartyKey(thirdParty);
        if (!thirdParties[thirdPartyKey]) {
          thirdParties[thirdPartyKey] = {
            thirdParty: thirdParty,
            addresses: []
          };
        }
        thirdParties[thirdPartyKey].addresses.push({
          address: address && address.address ? address.address : '',
          location: address && address.location && address.location.lat && address.location.lng ? address.location : { lat: 0, lng: 0 },
          time: address && address.time ? address.time : null,
          index: indexAddress,
          branchOffice: this.utils.getNestedValue(address, 'thirdPartyConsignment.branchOffice') || ''
        });
      }
    });

    return Object.values(thirdParties).map(thirdPartyGroup => ({
      name: thirdPartyGroup.thirdParty.name,
      documentNumber: thirdPartyGroup.thirdParty.documentNumber,
      documentType: thirdPartyGroup.thirdParty.documentType,
      addresses: thirdPartyGroup.addresses ? thirdPartyGroup.addresses : []
    }));
  }

  public getSenderAndDestinationConsignmentOptions(cargo: Cargo): { sender: { [key: string]: ConsignmentCityOption }, destination: { [key: string]: ConsignmentCityOption } } {
    const origin: Origin = this.utils.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin');
    const destination: Destination[] = this.utils.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
    let senderCityOptions: { [key: string]: ConsignmentCityOption } = {};
    let destinationCityOptions: { [key: string]: ConsignmentCityOption } = {};
    senderCityOptions = origin && origin.name
      ? {
        [`1.${origin.name}`]: {
          municipalityCode: origin.municipalityCode,
          name: origin.name,
          index: 0,
          type: 'origin',
          countryCode: origin.country && origin.country.code ? origin.country.code : 'CO',
          date: this.utils.getNestedValue(cargo, 'dateLoad'),
          thirdParties: origin.addresses && origin.addresses.length ? this.processAddressesWithThirdParties(origin.addresses) : []
        }
      }
      : {};
    if (!destination || !destination.length) {
      destinationCityOptions = {};
      return { sender: senderCityOptions, destination: destinationCityOptions };
    }
    destination.forEach((city, index) => {
      if (!city || !city.name) return;
      destinationCityOptions[`${index + 1}.${city.name}`] = {
        municipalityCode: city.municipalityCode ? city.municipalityCode : '',
        name: city.name,
        index: index,
        type: 'destination',
        countryCode: city.country && city.country.code ? city.country.code : 'CO',
        date: city.downloadDate ? city.downloadDate : '',
        thirdParties: city.addresses && city.addresses.length ? this.processAddressesWithThirdParties(city.addresses) : []
      }
    });
    return { sender: senderCityOptions, destination: destinationCityOptions };
  }

  public verifyDuplicatedConsignments(consignments: ConsignmentCargo[]): { duplicated: boolean, duplicatedConsignments: ConsignmentCargo[] } {
    if (!consignments || consignments.length <= 1) return { duplicated: false, duplicatedConsignments: [] };
    const fieldsToVerify = ['cargoNature.code', 'cargoNature.description',
      'merchandise.code', 'merchandise.description', 'packagingType.code', 'packagingType.description',
      'sender.name', 'sender.documentNumber', 'sender.documentType', 'sender.branchOffice',
      'recipient.name', 'recipient.documentNumber', 'recipient.documentType', 'recipient.branchOffice',
      'load.date', 'load.appointmentTime', 'unload.date', 'unload.appointmentTime',
    ];
    for (let index = 0; index < consignments.length; index++) {
      const consignment = consignments[index];
      const duplicatedConsignment = consignments.find((c, index2) => {
        if (index2 === index) return false;
        return fieldsToVerify.every(field => this.utils.getNestedValue(consignment, field) === this.utils.getNestedValue(c, field));
      });
      if (duplicatedConsignment)
        return { duplicated: true, duplicatedConsignments: [consignment, duplicatedConsignment] };
    }
    return { duplicated: false, duplicatedConsignments: [] };
  }

  public async openDialogConfirm(title: string, description: string = ''): Promise<{ confirm: boolean }> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
    };
    if (description) dialogConfig.data.description = description;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const response = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    return { confirm: response && response.state };
  }

  public async openDialogConfirmWithDescription(title: string, placeholder: string = 'Observaciones', maxLength: number = 200, minLength: number = 10): Promise<{ confirm: boolean, description: string }> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      inputText: true,
      placeholder: placeholder,
      maxLength: maxLength,
      minLength: minLength,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const response = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    return { confirm: response && response.state, description: response && response.inputText ? response.inputText : '' };
  }

  public async openDialogSelectConsignments(consignments: ConsignmentCargo[], title: string, description: string = ''): Promise<ConsignmentCargo[]> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      checkbox: consignments.map((consignment: ConsignmentCargo) => ({
        id: consignment && consignment.documentId ? consignment.documentId : '',
        name: `Remesa ${consignment.id}`,
      }))
    };
    if (description) dialogConfig.data.descriptionHTML = `<div class="text-center text-bold">${description}</div>`;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const response = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (!response || !response.state || !response.checkbox || !response.checkbox.length) return [];
    return response.checkbox
      .map((checkbox: { id: string, name: string }) => consignments.find((consignment: ConsignmentCargo) => consignment.documentId === checkbox.id))
      .filter((consignment: ConsignmentCargo) => !!consignment);
  }

  public async openDialogError(title: string, description?: string, descriptionHTML?: string): Promise<void> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      iconError: true,
      description: description,
      descriptionHTML: descriptionHTML,
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    return;
  }
}
